export default __webpack_public_path__ + "static/media/face_2_26.5fdf9358.png";